import _taggedTemplateLiteral from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

import styled from 'styled-components';
var Variants;

(function (Variants) {
  Variants["default"] = "#F5F5F5";
  Variants["warning"] = "#FFFFB5";
})(Variants || (Variants = {}));

export var List = styled.ul(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n"])));
export var Header = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 100%;\n  background-color: ", ";\n  position: sticky;\n  top: 0;\n  z-index: 1;\n"])), function (props) {
  return Variants[props.variant];
});
export var ListItemWrapper = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  border-top: 1px solid #E2E2E2;\n  gap: 15px;\n"])));
export var ActionButton = styled.button(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  height: 35px;\n  width: 35px;\n  background: none;\n  border: none;\n  cursor: pointer;\n"])));